<style scoped>
.card {
  position: relative !important;
}

.card-image {
  padding: 24px 0 0 0;
}

.card-image img {
  height: 150px;
  width: auto;
  margin: auto;
}

a.remove {
  position: absolute;
  top: 10px;
  right: 10px;
}

.wrapper-outer {
  position: relative;
  width: 100%;
  padding-bottom: 100%;
}

.wrapper-inner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
}

.wrapper-inner img {
  height: 100%;
  display: inline-block;
}
#productName {
  font-size: 28px !important;
}
#drink-image .img {
  width: 230px;
  height: auto;
  position: relative;
}
#drink-image .img i {
  position: absolute;
  right: 20px;
  top: 20px;
  color: #b03236;
  background: white;
  border-radius: 13px;
  padding: 5px;
  border: 1px solid #b03236;
}
#drink-image img {
  width: 220px;
  height: 230px;
  object-fit: contain;
}
.v-input__control>.v-input__slot>.v-text-field__slot>input[type=text], .v-input__control>.v-input__slot>.v-text-field__slot>input[type=number] {
    margin: 0!important;
}
.loader{
  position: fixed;
    top: 50%;
    z-index: 9;
    right: 50%;
}
</style>
<template lang="pug">
div
  div.loader.center-align(v-if="loading")
    .preloader-wrapper.active
      .spinner-layer.spinner-red-only
        .circle-clipper.left
          .circle
        .gap-patch
          .circle
        .circle-clipper.right
          .circle
  .row
    .col.s12
      h5 SAP Item details
    .col.m12.l12
      v-text-field#productName.col.s12.title(
        label='SKU',
        v-model='sapDetails.itemID'
      )
      v-text-field.col.s12.m6.pt-3(
        label='Item Group',
        v-model='sapDetails.itemGroup'
      )
      v-text-field.col.s12.m6.pt-3(
        label='accountCode',
        v-model='sapDetails.accountCode'
      )
      .col.s12.m6.pt-4
        label(for='productTag') valMethod
        .input-field
          select#productTag.browser-default(v-model='sapDetails.valMethod')
            option(value= '0') Moving Average
            option(value= '1') Standard
            option(value= '2') FIFO
      .col.s12.m6.pt-4
        label(for='productTag') status
        .input-field
          select#productTag.browser-default(v-model='sapDetails.status')
            option(value= '1') Active

  .row
    .col.s12
      h5 Other details
    .col.m12.l12
      v-text-field#productName.col.s12.title(
        label='Name',
        v-model='mutableProduct.name'
      )
      v-text-field.col.s12.m6.pt-3(
        label='Category',
        v-model='mutableProduct.category'
      )
      v-text-field.col.s12.m6.pt-3(
        label='Bottler',
        v-model='mutableProduct.bottler'
      )
      v-text-field.col.s12.m6.pt-3(
        label='Country',
        v-model='mutableProduct.country'
      )
      v-text-field.col.s12.m6.pt-3(
        label='Region',
        v-model='mutableProduct.region'
      )
      .col.s12.m6.pt-4
        label(for='productTag') Tag
        .input-field
          select#productTag.browser-default(v-model='mutableProduct.tags')
            option conventional
            option The Scotch Malt Whisky Society
  .row
    .row
      #drink-image.col.m2.l3.s12.no-padding
        div
          .img
            img(
              v-if="mutableProduct.variants[0].photo"
              :src='mutableProduct.variants[0].photo',
              :id='"var-" + 1',
               @click='choose(1)'
            )
            img(
              v-if="!mutableProduct.variants[0].photo"
              src="http://api.bevcity.ph/assets/images/bottle-thumb.png",
              :id='"var-" + 1',
               @click='choose(1)'
            )
            i.material-icons(@click='choose(1)') edit
            input#products-photos.d-none(
              type='file',
              ref='filesinput',
              @change='setPhotos($event, mutableProduct.variants[0], 1)',
              accept='.png, .jpg, .jpeg'
            )
            label File name should exactly match to product name: {{ mutableProduct.name }}
      .col.m10.l9.s12
        h2.col.s12.title.medium.pt-4 {{ mutableProduct.variants[0].variantCode }}
        .vspace.medium.col.s12
        v-text-field.col.s12.m6.pt-3(
          label='Age (years)',
          type='number',
          v-model='mutableProduct.variants[0].age',
        )
        v-text-field.col.s12.m6.pt-3(
          label='Price',
          type='number',
          v-model='mutableProduct.variants[0].price',
        )
        v-text-field.col.s12.m6.pt-3(
          label=' Volume (cl)',
          type='number',
          v-model='mutableProduct.variants[0].volumeCl',
        )
        v-text-field.col.s12.m6.pt-3(
          label='Alcohol Content',
          type='number',
          v-model='mutableProduct.variants[0].alcoholContent',
        )

    .col.s12.right-align.pt-5
      a.btn.btn-primary(@click='saveProduct()') Save
</template>
<script>
// import defaultPhoto from '../assets/default-no_prev.png'

export default {
  props: ['index', 'removable', 'onNewPSuccess', 'onNewPFailed'],
  data () {
    return {
      activeTab: null,
      loading: false,
      sapDetails: {
        itemID: '',
        itemName: '',
        itemGroup: '',
        inventoryUOM: 'Bottles',
        purchaseUOM: 'Bottles',
        salesUOM: 'Bottles',
        accountCode: '',
        valMethod: '',
        status: ''
      },
      mutableProduct: {
        name: '',
        productCode: '',
        category: '',
        bottler: '',
        country: '',
        region: '',
        variants: [{
          photo: '',
          variantCode: '',
          age: '',
          price: '',
          volumeCl: '',
          alcoholContent: ''
        }],
        tags: ''
      },
      photos: [],
      uploadMessage: null,
      uploadPercent: 0,
      uploading: false
    }
  },
  computed: {
    supplier () {
      return this.$store.state.profile.supplier
    }
  },
  mounted () {
    this.$M.updateTextFields()
    this.$M.Tabs.init(this.$refs.tabs)
  },
  methods: {
    choose (i) {
      this.$refs.filesinput.click()
    },
    setPhotos (e, variant, i) {
      const photos = {}
      this.photos = null

      let isValid = null
      Array.from(e.target.files).forEach((photo) => {
        const variantCode = photo.name.replace(/\.[^/.]+$/, '')
        isValid = this.mutableProduct.name === variantCode
        if (isValid) {
          photos[variantCode] = photo
          variant.photo = URL.createObjectURL(photo)
        }
      })
      this.photos = photos
    },
    removeProduct (e) {
      e.preventDefault()
      this.$emit('removeProduct', this.product.productCode, this.index)
    },
    photoLoaded (e) {
      this.$refs.photo.src = e.target.result
    },
    updateProducts () {
      const batchSize = 20
      const productKeys = Object.keys(this.mutableProduct)
      const batchCount = Math.ceil(productKeys.length / batchSize)

      const batches = []
      for (let i = 0, len = batchCount; i < len; i++) {
        batches.push(
          this.saveProduct(
            productKeys.slice(i * batchSize, (i + 1) * batchSize)
          )
        )
      }
    },
    saveProduct (productKeys) {
      this.loading = true

      this.sapDetails.itemName = this.mutableProduct.name
      this.mutableProduct.productCode = this.sapDetails.itemID
      this.mutableProduct.variants[0].variantCode = this.mutableProduct.name
      this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        this.$http.post(`${this.$config.API_URL}/item/additem`, this.sapDetails, {
          headers: {
            authorization: `Bearer ${accessToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
          }
        }).then(result => {
          if (result.data.status === 'Success' || result.data.message.includes('already exists')) {
            const products = [this.mutableProduct]
            const variants = {}
            let op = []
            let pro = this.mutableProduct.variants
            Object.keys(pro).forEach(function (key) {
              op.push(pro[key])
            })
            variants[this.mutableProduct.productCode] = op
            this.$store
              .dispatch('auth/getAccessToken')
              .then((accessToken) => {
                return this.$http
                  .post(
                    `${this.$config.API_URL}/suppliers/${this.supplier.code}/products`,
                    {
                      products: products,
                      variants: variants
                    },
                    {
                      headers: {
                        Authorization: `Bearer ${accessToken}`
                      }
                    }
                  )
                  .then((result) => {
                    this.loading = false
                    this.$snackbar.success('Products successfully added!')
                    this.$store.dispatch('modal/close')
                    this.onNewPSuccess(result.data)
                  })
              })
              .catch((err) => {
                this.onNewPFailed(err)
                this.loading = false
                this.$snackbar.error('Failed to connect to SAP, please try again.')
              })
            this.uploadPhotos()
          } else {
            this.loading = false
            this.$snackbar.error('Failed to connect to SAP, please try again.')
          }
        })
      }).catch(() => {
        this.loading = false
        this.$snackbar.error('Failed to connect to SAP, please try again.')
      })
    },
    uploadPhotos () {
      this.uploadMessage = 'Uploading photos'
      this.uploadPercent = 0
      const photoKeys = Object.keys(this.photos || {})
      if (!photoKeys.length) {
        return
      }

      const uploads = photoKeys.map((key) => {
        const photo = this.photos[key]
        return this.uploadPhoto(photo)
      })

      return Promise.each(uploads, (res, index, len) => {
        this.uploadPercent = Math.ceil(((index + 1) / len) * 100)
      })
    },
    uploadPhoto (photo) {
      return this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        const data = new FormData()
        data.append('photos', photo)
        return this.$http.post(
          `${this.$config.API_URL}/suppliers/${this.supplier.code}/products/photos`,
          data,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              'Content-Type': 'multipart/form-data'
            }
          }
        )
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-product-add-new.vue